/**
 * Service: permissions
 */
angular.module('acme.common.service.permissions', [
  'angular-md5',
  'acme.common.service.config',
  'acme.common.service.storage'
])
.service('PermissionsService', [
  '$rootScope',
  'StorageService',
  'ConfigService',
  'md5',
  function PermissionsService(
    $rootScope,
    StorageService,
    ConfigService,
    md5
  ) {
    var self = {
      /**
       * @type {Record<string, string> | false}
       */
      permissions: false,

      init: function() {
        return true;
      },

      store: function(permissions) {
        if (Array.isArray(permissions) && permissions.length > 0) {
          this.permissions = this.hash(permissions);
          var currentChecksum = ConfigService.get('app', 'rbacChecksum');

          if (!currentChecksum) {
            var newChecksum = this.fetchMD5();
            ConfigService.set({
              type: 'app',
              name: 'rbacChecksum',
              value: newChecksum,
            });
          }

          return true;
        }

        return false;
      },

      hash: function(permissions) {
        var o = {};
        var sorted = permissions.sort();

        for (var i = 0, ii = sorted.length; i < ii; i++) {
          o[sorted[i]] = sorted[i];
        }

        return o;
      },

      check: function(permissions, throwable) {
        var _isUserAllowed = true;
        var _userPermissions = this.permissions;

        if (permissions) {
          _isUserAllowed = [].concat(permissions)
            .filter(function (perm) {
              return _userPermissions.hasOwnProperty(perm);
            }).length > 0;
        }

        if (!_isUserAllowed && throwable) {
          $rootScope.$broadcast('PermissionsInterceptorFactory::error', {
            type: 'permission'
          });
        }

        return _isUserAllowed;
      },

      fetch: function() {
        return this.permissions;
      },

      fetchMD5: function() {
        var permissions = this.fetch();
        return md5.createHash(JSON.stringify(permissions));
      },

      hasPermissions: function() {
        if (this.permissions) {
          for (var i in this.permissions) {
            if (this.permissions.hasOwnProperty(i)) {
              return true;
            }
          }
        }

        return false;
      },

      refresh: function(scope) {
        scope.$emit('Permissions::refresh');
      },

      clearChecksum: function() {
        ConfigService.clear('app', 'rbacChecksum', true);
      },

      clearAll: function() {
        this.clearChecksum();
        StorageService.clearAll();
      },

      /**
       * @param {unknown} permissions
       * @returns {string[]}
       */
      normalizePermissions: function (permissions) {
        if (typeof permissions === 'string') {
          return [permissions];
        }

        if (Array.isArray(permissions)) {
          return permissions;
        }

        return [];
      },

      /**
       * @param {string | string[]} permissions
       */
      every: function (permissions) {
        var userPermissions = self.permissions ? self.permissions : {};
        var normalizedPermissions = self.normalizePermissions(permissions);

        return normalizedPermissions.every(function (permission) {
          return userPermissions.hasOwnProperty(permission);
        });
      },
      
      /**
       * @param {string | string[]} permissions
       */
      some: function (permissions) {
        var userPermissions = self.permissions ? self.permissions : {};
        var normalizedPermissions = self.normalizePermissions(permissions);

        return normalizedPermissions.some(function (permission) {
          return userPermissions.hasOwnProperty(permission);
        });
      },

    };

    return self;

}]);